var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IntroVideo",on:{"click":_vm.close}},[_c('div',{staticClass:"x-close",on:{"click":_vm.close}},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"frame"},[_c('video',{staticClass:"iframe",attrs:{"controls":"","autoplay":"","frameborder":"0","poster":_vm.coverUrl}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172ad231","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/CampusVideo.vue
// module id = null
// module chunks = 